// eslint-disable-next-line import/prefer-default-export
export const capitalize = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1)
